package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun ConeOfColdMetadata() {
    SpellMetadata(
        spellIndex = "cone-of-cold",
        castingTime = "1 action",
        range = "Self",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A small crystal or glass cone.",
        duration = "Instantaneous",
        damageBase = "Cold 8d8",
        damageScaling = mapOf("5" to "8d8", "6" to "9d8", "7" to "10d8", "8" to "11d8", "9" to "12d8"),
        savingThrow = "CON (Half)",
        aoe = "60-ft Cone",
        concentration = false
    )
}
